export default {
  //取得所有承攬商入廠施工群組
  GET_ALL_COURSE_LIST(state, res) {
    const data = res.data.data;
    state.allCourseList = data;
    //console.log(data);
  },
  //查詢 廠商施工負責人/安衛人員
  GET_ALL_PERSON_LIST_FOR_DUTY(state, res) {
    const data = res.data.data;
    state.allPersonListForDuty = data;
    //console.log(data);
  },
  //查詢 列出符合條件且尚未入廠核銷的單據列表
  GET_DAILY_PROJECT_LIST(state, res) {
    const data = res.data.data;
    state.dailyProjectData = JSON.parse(JSON.stringify(data));
    state.dailyProjectData.forEach((e, index) => (e.index = index + 1));
    state.dailyProjectList = state.dailyProjectData.slice(0, 10);
  },
};
